import getAccountDisclaimer from "assets/scripts/utils/getAccountDisclaimer";
function getUniqueDisclaimers(accounts, locale) {
    const disclaimers = [];
    let nextDisclaimerId = 1;
    const disclaimerIdMap = {};
    const allDisclaimers = (accounts || []).flatMap(it => getAccountDisclaimer(it, locale)).filter(it => it);
    for (const disclaimer of allDisclaimers) {
        if (!disclaimerIdMap[disclaimer]) {
            disclaimers.push(disclaimer);
            disclaimerIdMap[disclaimer] = nextDisclaimerId++;
        }
    }
    return {
        disclaimers,
        disclaimerIdMap
    };
}
export default getUniqueDisclaimers;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/getUniqueDisclaimers.ts